export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-11.9adfa0c4.png";